/**
 * @generated SignedSource<<bfb145279c6829902b1adb51775a02ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OccurrencePhysicalAddressInput_ProductFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "OccurrencePhysicalAddressInput_ProductFragment";
};
export type OccurrencePhysicalAddressInput_ProductFragment$key = {
  readonly " $data"?: OccurrencePhysicalAddressInput_ProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OccurrencePhysicalAddressInput_ProductFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OccurrencePhysicalAddressInput_ProductFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "c522965cbebacd4d6390c695e903c714";

export default node;
